export default __webpack_public_path__ + "static/media/forest-knight.14debe0e.jpg";